// Branch Balance Actions

// Get Branch Balance
export const GET_BRANCH_BALANCE_REQUEST = 'GET_BRANCH_BALANCE_REQUEST';
export const GET_BRANCH_BALANCE_SUCCESS = 'GET_BRANCH_BALANCE_SUCCESS';
export const GET_BRANCH_BALANCE_FAILURE = 'GET_BRANCH_BALANCE_FAILURE';

// Get Branch Balance Logs
export const GET_BRANCH_BALANCE_LOGS_REQUEST = 'GET_BRANCH_BALANCE_LOGS_REQUEST';
export const GET_BRANCH_BALANCE_LOGS_SUCCESS = 'GET_BRANCH_BALANCE_LOGS_SUCCESS';
export const GET_BRANCH_BALANCE_LOGS_FAILURE = 'GET_BRANCH_BALANCE_LOGS_FAILURE';

// Set Filters
export const SET_BRANCH_BALANCE_FILTERS = 'SET_BRANCH_BALANCE_FILTERS';
export const CLEAR_BRANCH_BALANCE_FILTERS = 'CLEAR_BRANCH_BALANCE_FILTERS';

// Clear Errors
export const CLEAR_BRANCH_BALANCE_ERRORS = 'CLEAR_BRANCH_BALANCE_ERRORS';

// Loading States
export const SET_BRANCH_BALANCE_LOADING = 'SET_BRANCH_BALANCE_LOADING';
export const SET_BRANCH_BALANCE_LOGS_LOADING = 'SET_BRANCH_BALANCE_LOGS_LOADING';
